<div id="externalPreviewPopup">
  <div class="toolbox row justify-content-between">
    <div class="actions col-is-auto" style="display: flex; align-items: center;">
      <a [routerLink]="['/pages', 'generator']">
        <img src="assets/logo_d.png" alt="Deebr" style="height: 30px; margin-left:30px">
      </a>
      <button nbButton appearance="outline" (click)="close()" size="small" style="width: 35px; margin-left: 20px;">
        <i class="bi-arrow-left"></i>
      </button>
      <div *ngIf="isDynamic" style="display: flex; align-items: center; gap: 8px; margin-left: 30px; border-left: 1px solid #e0e0e0; padding-left: 20px; position: relative;">
        <nb-icon icon="person-outline" style="color: #8f9bb3;"></nb-icon>
        <input nbInput type="text" placeholder="UUID du destinataire" [(ngModel)]="previewUuid"
          (keyup.enter)="!previewDisabled && applyPreviewUuid()" (focus)="onUuidFocus()" (blur)="onUuidBlur()"
          fieldSize="small" style="width: 320px; font-size: 12px;">
        <button nbButton size="small" status="primary" (click)="applyPreviewUuid()"
          [disabled]="!previewUuid.trim() || previewDisabled"
          [nbTooltip]="previewTooltip">
          Prévisualiser
        </button>
        <span *ngIf="isSyncing" style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.75rem; color: #d48806; font-weight: 600;">
          <nb-icon icon="sync-outline" style="font-size: 14px;"></nb-icon> Sync en cours…
        </span>
        <span *ngIf="isSyncError" style="display: inline-flex; align-items: center; gap: 4px; font-size: 0.75rem; color: #ff3d71; font-weight: 600;">
          <nb-icon icon="alert-triangle-outline" style="font-size: 14px;"></nb-icon> Erreur de sync
        </span>
        <div *ngIf="showUserDropdown && (isLoadingUsers || sampleUsers.length > 0)" class="uuid-dropdown"
          style="position: absolute; top: 100%; left: 28px; width: 370px; max-height: 300px; overflow-y: auto;
                 background: #fff; border: 1px solid #e4e9f2; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,0.15);
                 z-index: 1000; margin-top: 4px;">
          <div *ngIf="isLoadingUsers"
            style="padding: 12px; display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 12px; color: #8f9bb3;">
            <div class="uuid-dropdown-spinner"></div>
            Chargement des destinataires…
          </div>
          <div *ngFor="let user of sampleUsers"
            (mousedown)="selectUser(user.uuid)"
            style="padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #f0f0f0; font-size: 12px;"
            onmouseover="this.style.background='#f5f5f5'" onmouseout="this.style.background='#fff'">
            <div style="font-weight: 600; font-family: monospace; color: #3366ff;">{{ user.uuid }}</div>
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; margin-left: 20px; border-left: 1px solid #e0e0e0; padding-left: 20px;">
        <nb-toggle [checked]="isDarkMode" (checkedChange)="onDarkModeToggle($event)" status="info">
          Mode sombre
        </nb-toggle>
      </div>
    </div>
  </div>
  <div class="modal-container">
    <!-- Contenu de la popup -->
    <div id="content" class="preview-container-fluid">
      <div class="preview-row">
        <div class="preview-col-sm-2 esdev-score-col" style="margin-top: 20px;">
          <div style="display: flex; align-items: center; margin-left: 12px; margin-bottom: 8px;">
            <svg viewBox="0 0 36 36" width="24" height="24" style="margin-right: 6px;">
              <circle cx="18" cy="18" r="16" fill="none" stroke="#ffffff" stroke-width="2.5" />
              <circle cx="18" cy="18" r="16" fill="none" stroke="#35a2eb" stroke-width="2.5"
                [attr.stroke-dasharray]="htmlWeightPercent + ', 100'" stroke-dashoffset="25" />
            </svg>
            <span style="font-size: 12px;">
              Poids du HTML : {{ htmlWeightDisplay }}
            </span>

          </div>
          <div *ngIf="isGmailTruncated" class="alert alert-warning"
            style="font-size: 12px; text-align:left; padding: 4px 8px; line-height: 14px;width:250px">
            Tronquage Gmail probable ( > 102 Ko )
          </div>

          <div class="text-img-ratio-indicator">
            <i class="bi bi-check-circle-fill"></i>
            Rapport texte/images&nbsp;: {{ textImageRatio }}
          </div>

          <div class="alt-text-indicator" (mouseenter)="showAltTooltip = true" (mouseleave)="showAltTooltip = false">
            <i class="bi bi-check-circle-fill"></i>
            Textes alternatifs: {{ altTextStatus }}&nbsp;@if (imgsMissingAlt.length > 0) {
            <i class="bi bi-info-circle img-weight-info"></i>
            }

            @if (showAltTooltip && imgsMissingAlt.length > 0) {
            <div class="alt-tooltip">
              <b>Images sans texte alternatif :</b>
              @for (img of imgsMissingAlt; track img) {
              <div class="alt-img-row">
                @if (isAbsoluteUrl(img)) {
                <img [src]="img" class="alt-img-thumb" />
                } @else {
                <div class="alt-img-placeholder">?</div>
                }
              </div>
              }
            </div>
            }
          </div>
          <div class="img-weight-indicator" (mouseenter)="showImagesWeightTooltip = true"
            (mouseleave)="showImagesWeightTooltip = false">

            <i class="bi bi-image"></i>
            Poids total images :
            @if (totalImagesWeightDisplay !== null) {
            <span>{{ totalImagesWeightDisplay }} <i class="bi bi-info-circle img-weight-info"></i></span>
            }
            @if (totalImagesWeightDisplay === null) {
            <span>Calcul… </span>
            }

            @if (showImagesWeightTooltip && imagesWithWeight.length > 0) {
            <div class="img-weight-tooltip">
              <b>Détail des images :</b>
              <div class="img-weight-grid">
                @for (img of imagesWithWeight; track img) {
                <div class="img-weight-cell">
                  <img [src]="img.src" class="img-weight-thumb" />
                  <div class="img-weight-value">
                    @if (img.weight !== null) {
                    {{ (img.weight / 1024) | number:'1.0-2' }} KB
                    } @else {
                    Poids inconnu
                    }
                  </div>
                </div>
                }
              </div>
            </div>
            }

          </div>
        </div>
        <div class="preview-col-sm-8">
          <div class="esdev-desktop-device">
            <div class="esdev-email-window-panel">
              <div class="email-header-compact">
                <div class="email-avatar-compact">{{ initials }}</div>
                <div>
                  <div class="email-sender-name-compact">{{firstName}} {{lastName}}</div>
                  <div class="email-subject-line-compact">
                    {{objet}}
                  </div>
                </div>
              </div>
            </div>
            <div class="esdev-desktop-device-screen" #desktopContainer>
              <div class="loading-spinner" [class.hidden]="!spinnerinpreview">
                <div class="spinner"></div>
              </div>
              <iframe id="iframeDesktop" frameborder="0" width="100%" height="642"></iframe>
            </div>
          </div>
        </div>
        <div class="preview-col-sm-2 esdev-no-padding-left">
          <div class="esdev-mobile-device center-block">
            <div class="esdev-mobile-device-screen" #mobileContainer>
              <div class="loading-spinner" [class.hidden]="!spinnerinpreview">
                <div class="spinner"></div>
              </div>
              <iframe id="iframeMobile" frameborder="0" width="100%" height="568"
                (load)="onMobileIframeLoaded()"></iframe>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>